import React, { useState, useEffect } from 'react';
import axios from 'axios';
import 'react-datepicker/dist/react-datepicker.css';

const StaffManagement = () => {
  const [staff, setStaff] = useState([]);
  const [newStaff, setNewStaff] = useState({ name: '', role: '' });

  useEffect(() => {
    fetchStaff();
  }, []);

  const fetchStaff = async () => {
    try {
      const { data } = await axios.get('https://api.pranucollection.com/api/staff');
      setStaff(data);
    } catch (error) {
      console.error('Error fetching staff:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('https://api.pranucollection.com/api/staff', newStaff);
      setNewStaff({ name: '', role: '' });
      fetchStaff();
    } catch (error) {
      console.error('Error adding staff:', error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://api.pranucollection.com/api/staff/${id}`);
      fetchStaff();
    } catch (error) {
      console.error('Error deleting staff:', error);
    }
  };

  return (
    <div className="p-4 bg-white rounded-lg shadow">
      <form onSubmit={handleSubmit} className="mb-8 grid grid-cols-2 gap-4">
        <input
          type="text"
          placeholder="Staff Name"
          className="p-2 border rounded"
          value={newStaff.name}
          onChange={(e) => setNewStaff({...newStaff, name: e.target.value})}
          required
        />
        <input
          type="text"
          placeholder="Role"
          className="p-2 border rounded"
          value={newStaff.role}
          onChange={(e) => setNewStaff({...newStaff, role: e.target.value})}
          required
        />
        <button
          type="submit"
          className="col-span-2 bg-[#AB3430] text-white px-4 py-2 rounded hover:bg-[#8a2b28]"
        >
          Add Staff Member
        </button>
      </form>

      <div className="overflow-x-auto">
        <table className="w-full border-collapse">
          <thead className="bg-gray-50">
            <tr>
              <th className="p-3 text-left">Name</th>
              <th className="p-3 text-left">Role</th>
              <th className="p-3 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {staff.map(member => (
              <tr key={member._id} className="border-b hover:bg-gray-50">
                <td className="p-3">{member.name}</td>
                <td className="p-3">{member.role}</td>
                <td className="p-3">
                  <button 
                    onClick={() => handleDelete(member._id)}
                    className="text-red-600 hover:text-red-800"
                  >
                    Remove
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StaffManagement;